"use strict";

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var fclasses_1 = require("@bodiless/fclasses");

var lodash_1 = require("lodash");

var PageDimensionsProvider_1 = require("./PageDimensionsProvider");
/**
 * Generates an HOC which makes the underlying component designable at diferent
 * breakpoints. This allows responsive rendering or swapping a component entirely
 * depending on viewport size.
 *
 * In general, you should not use this to provide different styling at different
 * viewports: do that with media queries. Instead, use this if you want to produce
 * different *markup* at different viewports.
 *
 * Note that all variants will be rendered during SSR, and then replaced in the
 * browser with the one appropriate to the current viewport.  To avoid flicker when a
 * server renderd page is displayed in the browser, you should be sure to hide
 * variants which are not active using CSS.
 *
 * @param options
 * Options defining the variants, including a list of breakpoints.
 *
 * @return
 * HOC which produces a component designable at each breakpoint.
 */


var withResponsiveVariants = function withResponsiveVariants(options) {
  return function (Component) {
    var applyDesign = function applyDesign(design) {
      var components = Object.keys(design).reduce(function (comps, key) {
        var _a;

        return __assign(__assign({}, comps), (_a = {}, _a[key] = design[key](Component), _a));
      }, {
        _default: Component
      }); // During SSR we render all the variants

      var SSRComponent = function SSRComponent(props) {
        var variants = Object.keys(components).map(function (key) {
          var Variant = components[key];
          return react_1.default.createElement(Variant, __assign({
            key: key
          }, props));
        });
        return react_1.default.createElement(react_1.default.Fragment, null, variants);
      }; // In the browser (on effect) we replace with a component which renders
      // the proper variant for the viewport.


      var ProperComponent = function ProperComponent(props) {
        var size = PageDimensionsProvider_1.usePageDimensionsContext().size; // eslint-disable-next-line no-underscore-dangle

        var FinalComponent = components[size] || components._default;
        return react_1.default.createElement(FinalComponent, __assign({}, props));
      };

      return {
        SSRComponent: SSRComponent,
        ProperComponent: ProperComponent
      };
    };

    var ResponsiveVariants = function ResponsiveVariants(props) {
      var components = props.components,
          rest = __rest(props, ["components"]);

      var SSRComponent = components.SSRComponent,
          ProperComponent = components.ProperComponent;

      var _a = react_1.useState(false),
          isBrowser = _a[0],
          setIsBrowser = _a[1];

      react_1.useEffect(function () {
        return setIsBrowser(true);
      }, []);
      return isBrowser ? react_1.default.createElement(ProperComponent, __assign({}, rest)) : react_1.default.createElement(SSRComponent, __assign({}, rest));
    };

    return lodash_1.flow(fclasses_1.designable(applyDesign), PageDimensionsProvider_1.withPageDimensionsContext(options))(ResponsiveVariants);
  };
};

exports.default = withResponsiveVariants;